<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
}

/* 鼠标移入图片放大 */

.img-zoom{
    overflow: hidden;
}
.img-zoom img{
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
    transition: all 0.6s;
}
.img-zoom img:hover{
    transform: scale(1.1);
}
</style>
